module.exports = __webpack_public_path__ + "img/LAOVLALA.2840cc36.jpg";